/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:48 GMT
 *
 */


const theme = { appearances: {}, rules: [], tokens: { maxLines: 8, minLines: 5 } }
export default theme
